export { default } from './module-title-bar';